module.exports = __webpack_public_path__ + "img/wangxuanqi.7e6a93e2.jpg";